<template>
    <AdminHomeNav/>
    <div class="bg-blue-500">
        <div class="flex items-center justify-center">
            <div class="grid md:grid-cols-2 gap-4 mx-4 mt-5 mb-5">
                <div class="my-5 flex items-center justify-center">
                    <!-- <DomesticSVG/> -->
                    <festivitiesSVG/>
                </div>
                <div class="">
                    <a href="#" class="flex flex-row items-center h-full">
                        <div class="flex flex-col justify-between p-4 leading-normal w-full">
                            <h5 class="mb-3 text-5xl font-bold tracking-tight text-white text-center">Holiday Packages</h5>
                            <div class="px-6 pt-4 pb-2 flex items-center justify-center">
                                <button @click="addFlights" href="#Top" type="button" class="text-white w-80 hover:text-white bg-yellow-400 border border-yellow-400 hover:bg-yellow-600 font-medium rounded-full text-md px-5 py-2.5 text-center me-2 mb-2">Add Flights</button>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div v-if="length_of_data === 0">
        <div class="my-5">
            <div class="my-5 flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" class="w-80 h-80" viewBox="0 0 922.43055 543.51482" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M429.40405,719.95523c-.05566-.24511-5.43994-24.79785,5.55615-45.19043,10.9961-20.39166,34.46827-29.38476,34.70411-29.47363l1.07275-.40234.25342,1.11816c.05566.24512,5.43994,24.79785-5.55615,45.19043-10.99561,20.39166-34.46827,29.38477-34.70411,29.47363l-1.07324.40235Zm39.86182-72.33782c-4.70166,2.02246-23.25781,10.874-32.54492,28.09667-9.28809,17.22461-6.48584,37.59375-5.59229,42.63086,4.69971-2.01757,23.24854-10.85546,32.54492-28.09668C472.96118,673.02457,470.15991,652.65738,469.26587,647.61741Z" transform="translate(-138.78472 -178.24259)" fill="#f1f1f1"/><path d="M457.03116,684.04435c-19.76056,11.88861-27.371,35.50268-27.371,35.50268s24.42779,4.33881,44.18835-7.5498,27.371-35.50269,27.371-35.50269S476.79172,672.15574,457.03116,684.04435Z" transform="translate(-138.78472 -178.24259)" fill="#f1f1f1"/><path d="M403.38208,533.755h55.82731V505.49264H403.38208Z" transform="translate(-138.78472 -178.24259)" fill="#6c63ff"/><path d="M415.04913,508.29308a7.93668,7.93668,0,0,0-8.31091-8.89017L398.88446,483.055l-11.09864,2.34969,11.41528,22.93065a7.97965,7.97965,0,0,0,15.848-.04225Z" transform="translate(-138.78472 -178.24259)" fill="#ffb7b7"/><polygon points="105.767 519.858 115.004 524.585 137.634 491.205 124 484.228 105.767 519.858" fill="#ffb7b7"/><path d="M243.73878,693.879l18.19172,9.3096.00074.00038a13.02378,13.02378,0,0,1,5.65977,17.526l-.19281.37672-29.785-15.24261Z" transform="translate(-138.78472 -178.24259)" fill="#2f2e41"/><polygon points="212.454 532.791 222.83 532.79 227.767 492.766 212.452 492.766 212.454 532.791" fill="#ffb7b7"/><path d="M348.59142,707.64523l20.43546-.00083h.00082a13.02377,13.02377,0,0,1,13.02307,13.02286v.4232l-33.45873.00124Z" transform="translate(-138.78472 -178.24259)" fill="#2f2e41"/><path d="M302.70032,384.56392s-6.94873-5.32368-6.94873,7.68016l-1.09716,42.97236,12.25169,40.59517,7.13159-13.166-2.92578-28.52633Z" transform="translate(-138.78472 -178.24259)" fill="#2f2e41"/><path d="M377.03136,502.10087s8.05774,39.24119-2.14873,71.4453L369.24221,697.3668l-20.68154-1.61155-7.252-91.85825-6.98338-45.66053L319.8214,599.86813l-47.80927,88.098-22.02449-17.18985s24.40667-66.59522,42.43744-80.57741l9.043-102.99572Z" transform="translate(-138.78472 -178.24259)" fill="#2f2e41"/><circle cx="213.7317" cy="130.27454" r="23.5814" fill="#ffb8b8"/><path d="M350.84761,313.51884c2.82683.3678,4.95918-2.52447,5.94818-5.19806s1.74257-5.7862,4.2003-7.23041c3.35778-1.9731,7.65389.4,11.49368-.251,4.33631-.73516,7.15572-5.3308,7.37669-9.72343s-1.5271-8.61741-3.24227-12.66737l-.5988,5.03318a9.98113,9.98113,0,0,0-4.36168-8.72436l.77179,7.38543a7.83853,7.83853,0,0,0-9.01785-6.48609l.12154,4.40051c-5.00844-.59556-10.06064-1.19195-15.08391-.73823s-10.08162,2.043-13.88883,5.35126c-5.695,4.94857-7.77493,13.097-7.07665,20.6092s3.79932,14.56944,7.0313,21.38674c.81317,1.71525,1.9379,3.65079,3.82353,3.86929a3.85158,3.85158,0,0,0,3.7712-2.84219,10.30188,10.30188,0,0,0-.04573-5.06077c-.4765-2.5321-1.07717-5.12024-.62916-7.65754s2.27332-5.04462,4.831-5.35557,5.1749,2.61264,3.94519,4.8768Z" transform="translate(-138.78472 -178.24259)" fill="#2f2e41"/><polygon points="239.706 334.352 160.991 329.274 166.915 304.729 238.859 320.81 239.706 334.352" fill="#cbcbcb"/><path d="M329.94662,340.67725l4.93725-6.85464s5.51849,1.8754,20.29759,9.23183l1.04414,6.42222,25.65358,157.78706-46.62958-2.01147-12.69811-.27017-4.15546-9.315-5.12418,9.11755-12.40014-.26383-12.61742-7.31445,12.43455-38.03511,4.02295-34.74361-6.21728-32.73214s-7.82347-30.05728,22.30906-46.26386Z" transform="translate(-138.78472 -178.24259)" fill="#2f2e41"/><polygon points="255.787 321.656 257.48 327.581 269.329 319.864 264.858 314.745 255.787 321.656" fill="#cbcbcb"/><path d="M338.76693,359.748s18.36836-23.45,29.47029,2.68606l3.50019,27.38928s13.44915,34.04483,13.85365,47.81926c0,0,9.11826,17.97712,9.0345,27.41942l13.48858,30.53718-13.8346,8.58887L355.991,445.481Z" transform="translate(-138.78472 -178.24259)" fill="#2f2e41"/><path d="M520.78472,721.75741h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z" transform="translate(-138.78472 -178.24259)" fill="#cbcbcb"/><path d="M597.358,414.94225h460.06211V182.03786H597.358Z" transform="translate(-138.78472 -178.24259)" fill="#fff"/><path d="M1061.21528,418.73745H593.5628V178.24259h467.65248ZM601.153,411.14723h452.472V185.83281H601.153Z" transform="translate(-138.78472 -178.24259)" fill="#e5e5e5"/><rect x="739.86245" y="46.21081" width="86.67858" height="148.0759" fill="#e5e5e5"/><rect x="550.66766" y="46.20822" width="174.83378" height="40.75957" fill="#6c63ff"/><rect x="550.66766" y="98.31856" width="174.83378" height="43.85523" fill="#e5e5e5"/><rect x="550.66766" y="153.52456" width="174.83378" height="40.75957" fill="#e5e5e5"/></svg>
            </div>
            <div class="">
                <a href="#" class="flex flex-row items-center h-full">
                    <div class="flex flex-col justify-between p-4 leading-normal w-full">
                        <h5 class="mb-3 text-2xl font-bold tracking-tight text-blue-500 text-center">Add some destinations</h5>
                    </div>
                </a>
            </div>
        </div>
    </div>
    <div v-else>
        <div v-if="page_loaded === false">
            <div role="status" class="flex justify-center items-center my-5">
                <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                </svg>
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <div v-else>
            <div class="mx-5 my-5">
                <div class="mb-10">
                    <section id="feature">
                        <div class="flex items-center justify-center my-10">
                            <div class="grid grid-cols-1 sm:grid-cols-3 sm:gap-10 gap-4">
                                <!-- 1 -->
                                <div v-for="flights in flights_arr.slice().reverse()" :key="flights">
                                    <div class="max-w-sm rounded overflow-hidden shadow-lg">
                                        <div class="aspect-w-16 aspect-h-9">
                                            <img class="object-cover h-48 w-96" :src="flights.photo_link" alt="Sunset in the mountains">
                                        </div>
                                        <div class="px-6 py-4 bg-white h-64 overflow-hidden">
                                            <div class="font-bold text-xl mb-2">{{ flights.destination }}</div>
                                            <p class="text-gray-700 text-base text-justify">
                                                {{ truncatedDescription(flights.description) }}
                                            </p>
                                        </div>
                                        <div class="px-6 pt-4 pb-2 flex items-center justify-center bg-white">
                                            <button @click="editFlight(flights.id)" type="button" class="text-green-700 w-80 hover:text-white border border-green-700 hover:bg-green-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2">Edit</button>
                                            <button @click="deleteFlight(flights.id)" type="button" class="text-red-700 w-80 hover:text-white border border-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2">Delete</button>
                                            <!-- <button @click="deleteFlight(flights.id)" type="button" class="text-blue-700 w-80 hover:text-white border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2">Share</button> -->
                                            <ShareNetwork @click="() => triggerShare(flights.id, flights.destination)" class="text-blue-700 w-80 hover:text-white border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
                                                network="facebook"
                                                title="Book your trip with AirProve and get extremely low prices!"
                                                :url="flights.url"
                                                @change="change" @close="close">
                                                <router-link :to="{
                                                    name: 'specific-trip',
                                                    params: {
                                                        destination: flights.destination,
                                                        id: flights.id,
                                                    }
                                                }" v-on:click.prevent="shareSpecificTrip">
                                                    Share
                                                </router-link>
                                            </ShareNetwork>
                                            <!-- <ShareNetwork
                                                network="facebook"
                                                url="https://news.vuejs.org/issues/180"
                                                title="Say hi to Vite! A brand new, extremely fast development setup for Vue."
                                                description="This week, I’d like to introduce you to 'Vite', which means 'Fast'. It’s a brand new development setup created by Evan You."
                                                quote="The hot reload is so fast it\'s near instant. - Evan You"
                                                hashtags="vuejs,vite"
                                            >
                                                Share on Facebook
                                            </ShareNetwork> -->
                                        </div>
                                    </div>
                                </div>
                                <!-- End -->
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
    <AdminFooter/>

    <div v-if="modal === true">
        <PopUpModal>
            <!-- Modal content -->
            <div class="relative bg-white">
                <!-- Modal header -->
                <div class="flex items-center justify-between p-4 md:p-5">
                    <h3 class="text-lg font-semibold text-gray-900 ">
                        Edit
                    </h3>
                    <button @click="toggleModal" type="button" class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center" data-modal-toggle="crud-modal">
                        <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                        </svg>
                        <span class="sr-only">Close modal</span>
                    </button>
                </div>
                <!-- Modal body -->
                <div class="p-4 md:p-5">
                    <div v-for="flights in flights_arr" :key="flights">
                        <div v-if="flights.id === this.id_holder">
                            <div class="grid gap-4 mb-4 grid-cols-2">
                                <div class="col-span-2">
                                    <label for="name" class="block mb-2 text-sm font-medium text-gray-900 ">Destination</label>
                                    <input v-model="flights.destination" type="text" name="name" id="name" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5" placeholder="Type product name" required="">
                                </div>
                                <div class="col-span-2">
                                    <label for="name" class="block mb-2 text-sm font-medium text-gray-900 ">Photo Link</label>
                                    <input v-model="flights.photo_link" type="url" name="name" id="name" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5" placeholder="Type product name" required="">
                                </div>
                                <div class="col-span-2 sm:col-span-1">
                                    <label for="price" class="block mb-2 text-sm font-medium text-gray-900 ">Price</label>
                                    <input v-model="flights.price" type="number" name="price" id="price" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5" placeholder="$2999" required="">
                                </div>
                                <div class="col-span-2 sm:col-span-1">
                                    <label for="price" class="block mb-2 text-sm font-medium text-gray-900 ">Promo Code</label>
                                    <input v-model="flights.promo_code" type="text" name="price" id="price" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5" placeholder="AirProve2024" required="">
                                </div>
                                <div class="col-span-2">
                                    <label for="description" class="block mb-2 text-sm font-medium text-gray-900 ">Destination Description</label>
                                    <textarea v-model="flights.description" id="description" rows="4" class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500" placeholder="Write product description here"></textarea>                    
                                </div>
                            </div>
                            <button @click="updateDestination(flights.destination, flights.photo_link, flights.price, flights.promo_code, flights.description)" type="submit" class="text-white inline-flex items-center bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center ">
                                <svg class="me-1 -ms-1 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd"></path></svg>
                                Update Destination
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </PopUpModal>
    </div>

    <div v-if="add_flights === true">
        <PopUpModal>
            <!-- Modal content -->
            <div class="relative bg-white">
                <!-- Modal header -->
                <div class="flex items-center justify-between p-4 md:p-5">
                    <h3 class="text-lg font-semibold text-gray-900 ">
                        Add a Featured Destination
                    </h3>
                    <button @click="addFlights" type="button" class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center" data-modal-toggle="crud-modal">
                        <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                        </svg>
                        <span class="sr-only">Close modal</span>
                    </button>
                </div>
                <!-- Modal body -->
                <form class="p-4 md:p-5" @submit.prevent="add_destination">
                    <div class="grid gap-4 mb-4 grid-cols-2">
                        <div class="col-span-2">
                            <label for="name" class="block mb-2 text-sm font-medium text-gray-900 ">Destination</label>
                            <input v-model="destination" type="text" name="name" id="name" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5" placeholder="Destination" required="">
                        </div>
                        <div class="col-span-2">
                            <label for="name" class="block mb-2 text-sm font-medium text-gray-900 ">Photo Link</label>
                            <input v-model="photo_link" type="url" name="name" id="name" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5" placeholder="Photo URL" required="">
                        </div>
                        <div class="col-span-2 sm:col-span-1">
                            <label for="price" class="block mb-2 text-sm font-medium text-gray-900 ">Price</label>
                            <input v-model="price" type="number" name="price" id="price" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5" placeholder="$2999" required="">
                        </div>
                        <div class="col-span-2 sm:col-span-1">
                            <label for="price" class="block mb-2 text-sm font-medium text-gray-900 ">Promo Code</label>
                            <input v-model="promo_code" type="text" name="price" id="price" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5" placeholder="AirProve2024" required="">
                        </div>
                        <div class="col-span-2">
                            <label for="description" class="block mb-2 text-sm font-medium text-gray-900 ">Destination Description</label>
                            <textarea v-model="description" id="description" rows="4" class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500" placeholder="Destination description"></textarea>                    
                        </div>
                    </div>
                    <button type="submit" class="text-white inline-flex items-center bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center ">
                        <svg class="me-1 -ms-1 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd"></path></svg>
                        Add Flight
                    </button>
                </form>
            </div>
        </PopUpModal>
    </div>
</template>

<script>
import AdminFooter from '@/components/AdminFooter.vue'
import AdminHomeNav from '@/components/AdminHomeNav.vue'
import PopUpModal from '@/components/PopUpModal.vue'
import Swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

import Parse from 'parse';
import festivitiesSVG from '@/components/festivitiesSVG.vue'
Parse.serverURL = 'https://parseapi.back4app.com';
Parse.initialize('A9iU0asj7lBx8THtL3OuHVdKAebIUED9GJKzrpWn', 'AQmS27wK0tZHTPFga30Afa0eMTqnBmzf7zk9yX4F');

export default{
    components: { AdminHomeNav, AdminFooter, PopUpModal, festivitiesSVG },
    data(){
        return{
            modal: false,
            add_flights: false,
            destination: '',
            price: '',
            promo_code: '',
            description: '',
            photo_link: '',
            id_holder: '',
            length_of_data: '',

            page_loaded: false,
            flights_arr: [],

            shareUrl: '',
            shareTitle: 'Your Post Title',
        }
    },

    computed:{
        computedUrl(){
            console.log(this.shareUrl);
            return this.shareUrl;
        }
    },

    methods:{
        truncatedDescription(description) {
            const maxCharacters = 340;
            if (description && description.length > maxCharacters) {
                return description.substring(0, maxCharacters) + '...';
            } else {
                return description;
            }
        },
        
        triggerShare(id, destination){
            this.shareUrl = `${window.location.origin}/booking/destination=${destination}/id=${id}`;
            console.log(this.shareUrl);
            navigator.clipboard.writeText(this.shareUrl);
        },

        shareSpecificTrip(){
            console.log('shareSpecificTrip is called');
        },

        toggleModal(){
            this.modal = !this.modal;
            console.log(this.modal);
        },

        addFlights(){
            this.add_flights = !this.add_flights;
        },

        editFlight(id){
            this.modal = true;
            this.id_holder = id;
            console.log(id);
        },

        async deleteFlight(id){
            const admin_holiday = Parse.Object.extend("holiday");
            const holiday = new Parse.Query(admin_holiday);

            holiday.equalTo("objectId", id);
            const dom = await holiday.first();

            dom.destroy().then((dom) => {
                console.log(dom.id);
                this.$router.push({name: 'reload-page'});
            }, (error) => {
                alert(error.message);
            });
        },

        async updateDestination(destination, photo_link, price, promo_code, description){
            const Holiday = Parse.Object.extend("holiday");
            const holiday = new Parse.Query(Holiday);

            holiday.equalTo("objectId", this.id_holder);
            const dom = await holiday.first();

            dom.set("destination", destination);
            dom.set("photo_link", photo_link);
            dom.set("price", price);
            dom.set("promo_code", promo_code);
            dom.set("description", description);

            dom.save().then((dom) => {
                console.log(dom.id);
                this.$router.push({name: 'reload-page'});
            }, (error) => {
                console.log(error.message)
            })
        },

        add_destination(){
            const admin_holiday = Parse.Object.extend("holiday");
            const holiday_flight = new admin_holiday();
            holiday_flight.set("destination", this.destination);
            holiday_flight.set("price", this.price);
            holiday_flight.set("promo_code", this.promo_code);
            holiday_flight.set("description", this.description);
            holiday_flight.set("photo_link", this.photo_link);

            holiday_flight.save().then((holiday_flight) => {
                console.log(holiday_flight.id);
                this.popUp();
            }, (error) => {
                alert('Error:' + error.message);
                console.log(error.message);
            });

            this.destination = '';
            this.price = '';
            this.promo_code = '';
            this.description = '';
            this.photo_link = '';
            this.add_flights = false;
        },

        popUp(){
            Swal.fire({
                icon: 'success', title: "Flight Added!",
                showCancelButton: false,
                showConfirmButton: false,
                showCloseButton: true,
            });
            this.$router.push({name: 'reload-page'});
        },
    },
    created() {
        console.log('HolidayAdmin component created');
    },

    mounted: async function(){
        console.log("holidayAdmin component mounted");
        const Holiday = Parse.Object.extend("holiday");
        const holiday = new Parse.Query(Holiday);
        const query = await holiday.find();

        for(let i = 0; i < query.length; i++){
            this.flights_arr.push({
                id: query[i].id,
                destination: query[i].get("destination"),
                description: query[i].get("description"),
                photo_link: query[i].get("photo_link"),
                price: query[i].get("price"),
                promo_code: query[i].get("promo_code"),
                url: `${window.location.origin}/booking/destination=${query[i].get("destination")}/id=${query[i].id}`,
            })
            this.page_loaded = true;
        }

        this.length_of_data = this.flights_arr.length;
    }
}
</script>